import { io } from "socket.io-client";


// const SOCKET_URL = process.env.REACT_APP_API_DOMAIN;
// const SOCKET_URL = "http://chat.dubbgame.trangotechdevs.com:3040";
const SOCKET_URL = "https://chat.dubbsgames.com";

const socket = io(SOCKET_URL, {
    transports: ['websocket'],
    autoConnect: false
})


class SocketIo {
    connectToSocket = (api_token, callback = () => { }, success = () => { }) => {
        socket.io.opts.query = {
            authorization: api_token
        }
        socket.connect();
        socket.on('connect', () => {
            console.log('Socket Connected')
            success()
        })

        socket.on('connect_error', function (err) {
            console.log('Socket Connection Error')
            callback()
        });
    }
    emit = (eventName, params = {}, onSuccess) => {
        socket.emit(eventName, params, res => {
            onSuccess(res.data);
        })

    }

    on = (eventName, callback) => {
        socket.on(eventName, callback)
    }


    dispose = (eventName) => {
        socket.off(eventName);
    }

    disconnect = () => {
        socket.disconnect();
    }

    getStatus = () => {
        return socket.connected
    }
}

export default new SocketIo();